import React from "react";
import { Sidebar } from "../components/Sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import { Header } from "../components/Header";

const Layout = () => {
  return (
    <div className="w-full flex items-start justify-center">
      <div className="w-[17%] block h-screen sticky top-0">
        <Sidebar />
      </div>

      <div className="w-[83%] ">
        <div className="w-[95%] mx-auto ">
          <div className="w-full ">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
